import React, { useEffect, useState, useContext, useRef } from "react";

import { Link, useLocation } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

import AddMoodboardModal from "pages/de/collection/components/AddMoodboardModal";
import ImportMoodboardModal from "pages/de/collection/detail/components/ImportMoodboardModal";

const EmptyMoodboardRecord = ({
  content = null,
  refresh = () => {},
  collection,
  selectedMoodboards,
  importOnly = false,
  createOnly = false,
  sx = {},
}) => {
  const [importMoodboardVisible, setImportMoodboardVisible] = useState(false);
  const [createMoodboardVisible, setCreateMoodboardVisible] = useState(false);

  return (
    <SuiBox>
      <SuiBox
        sx={{
          border: "1px dashed",
          borderWidth: ({ borders }) => borders.borderWidth[2],
          borderColor: ({ borders }) => borders.borderColor,
          height: 240,
          width: 200,
          borderRadius: 4,
          ...sx,
        }}
      >
        {content ? (
          content
        ) : (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            gap={1}
            sx={{ height: "100%", width: "100%" }}
          >
            {!importOnly || createOnly ? (
              <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                <AddIcon fontSize="small" />
                <SuiTypography
                  variant="body2"
                  textTransform="uppercase"
                  fontWeight="bold"
                  onClick={() => setCreateMoodboardVisible(true)}
                  sx={{ cursor: "pointer" }}
                >
                  Create
                </SuiTypography>{" "}
              </SuiBox>
            ) : null}

            {!createOnly || importOnly ? (
              <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                <SystemUpdateAltIcon fontSize="small" />
                <SuiTypography
                  variant="body2"
                  textTransform="uppercase"
                  fontWeight="bold"
                  onClick={() => setImportMoodboardVisible(true)}
                  sx={{ cursor: "pointer" }}
                >
                  Import
                </SuiTypography>
              </SuiBox>
            ) : null}
          </SuiBox>
        )}
      </SuiBox>
      {importMoodboardVisible ? (
        <ImportMoodboardModal
          visible={importMoodboardVisible}
          handleClose={() => setImportMoodboardVisible(false)}
          collection={collection}
          handleRefresh={refresh}
          selectedMoodboards={selectedMoodboards}
        />
      ) : null}
      {createMoodboardVisible && collection?.id ? (
        <AddMoodboardModal
          handleClose={() => {
            setCreateMoodboardVisible(false);
          }}
          visible={createMoodboardVisible}
          collection={collection}
          handleRefresh={refresh}
        />
      ) : null}
    </SuiBox>
  );
};

export default EmptyMoodboardRecord;
